<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [class.show]="showModal">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" id="parcelForm">
        <div class="modal-dialog ">
            <div class="modal-content" [class.sk-loading]="loading.global">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{isEditModal ? 'Edit' : 'Create'}} a Parcel</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Type / inOut ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Type</label>
                        </div>
                        <div class="col-md-9">
                            <div class="parcel-type-switch clearfix">
                                <input
                                    type="radio"
                                    formControlName="inOut"
                                    id="incomingRadio"
                                    [value]="'Incoming'"
                                >
                                <label class="col-md-6" for="incomingRadio">Incoming</label>

                                <input
                                    type="radio"
                                    formControlName="inOut"
                                    id="outgoingRadio"
                                    [value]="'Outgoing'"
                                >
                                <label class="col-md-6" for="outgoingRadio">Outgoing</label>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Building ___ -->
                    <div class="row m-b-sm" [hidden]="parcelsService.buildingsForUpdate.length < 2">
                        <div class="col-md-3">
                            <label>Building</label>
                        </div>
                        <div class="col-md-9">
                            <select class="form-control" formControlName="buildingId">
                                <option value="" hidden></option>
                                <option *ngFor="let build of parcelsService.buildingsForUpdate" [value]="build.id">
                                    {{build.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ Unit ___ -->
                    <div class="row m-b-sm" [class.sk-loading]="buildingId.value && loading.suites">
                        <div class="col-md-3">
                            <label>Unit</label>
                        </div>
                        <div class="col-md-9">
                            <search-select
                                formControlName="suiteId"
                                [data]="suites">
                            </search-select>
                            <input *ngIf="suiteId.value == 0"
                                   class="form-control"
                                   formControlName="suiteNumber"
                                   placeholder="Other Unit Number">
                            <spinner [spinnerShow]="buildingId.value && loading.suites"></spinner>
                        </div>
                    </div>

                    <!-- ___ Resident ___ -->
                    <div class="row m-b-sm" [class.sk-loading]="suiteId.value && loading.residents">
                        <div class="col-md-3">
                            <label>Resident</label>
                        </div>
                        <div class="col-md-9">
                            <search-select-with-label
                                formControlName="residentId"
                                [labelClass]="useParcelsWaiver ? 'fa fa-check' : ''"
                                [labelNotMatchClass]="useParcelsWaiver ? 'fa fa-times' : ''"
                                [labelCondition]="'parcelWaiverSigned'"
                                [labelPopoverText]="'Waiver Signed'"
                                [negativeLabelPopoverText]="'Waiver is not signed'"
                                [data]="residentsToSearchSelect(residents)">
                            </search-select-with-label>
                            <input
                                *ngIf="residentId.value == 0"
                                class="form-control"
                                placeholder="Other Resident Name"
                                formControlName="residentFullName"
                            >
                            <spinner [spinnerShow]="suiteId.value && loading.residents"></spinner>
                        </div>
                    </div>

                    <!-- ___ Parcel Type ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Parcel Type</label>
                        </div>
                        <div class="col-md-9">
                            <select
                                class="form-control form-control__parcel-type"
                                formControlName="parcelTypeId">
                                <option value="" hidden></option>
                                <option *ngFor="let parcelType of parcelTypes" [value]="parcelType.id">
                                    {{parcelType.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <!-- ___ # of Pieces / numberPieces ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label># of Pieces</label>
                        </div>
                        <div class="col-md-9">
                            <input
                                type="number"
                                min="1"
                                class="form-control"
                                formControlName="numberPieces"
                            >
                        </div>
                    </div>

                    <!-- ___ Courier / postService ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Courier</label>
                        </div>
                        <div class="col-md-9">
                            <select
                                class="form-control"
                                formControlName="parcelPostServiceId"
                            >
                                <option value="" hidden></option>
                                <option *ngFor="let postService of parcelsService.postServices"
                                        [value]="postService.id">
                                    {{postService.name}}
                                </option>
                                <option [value]="-1">
                                    Other
                                </option>
                            </select>
                            <input
                                *ngIf="parcelPostServiceId.value == -1"
                                class="form-control"
                                placeholder="Other Courier"
                                formControlName="parcelPostServiceName"
                            >
                        </div>
                    </div>

                    <!-- ___ Barcode ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Barcode</label>
                        </div>
                        <div class="col-md-9">
                            <input
                                class="form-control"
                                type="text"
                                formControlName="barCode"
                            >
                        </div>
                    </div>

                    <!-- ___ Date / CreatedAt ___ -->
                    <div class="row m-b-sm long-date-field">
                        <div class="col-md-3">
                            <label>Date</label>
                        </div>
                        <div class="col-md-9">
                            <mat-form-field style="width: 100%;" class="parcels-datepicker">
                                <input
                                    matInput
                                    formControlName="date"
                                    [matDatepicker]="picker"
                                    (focus)="picker.open()"
                                    (click)="picker.open()"
                                    placeholder="Choose a date">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- ___ Time / CreatedAt ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Time</label>
                        </div>
                        <div class="col-md-9">
                            <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                <input id="timepicker1" class="form-control input-small" formControlName="time">
                                <span class="input-group-addon">
                                    <i class="glyphicon glyphicon-time"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- ___ Description  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-3">
                            <label>Description</label>
                        </div>
                        <div class="col-md-9">
                            <textarea class="form-control" formControlName="description"></textarea>
                        </div>
                    </div>

                    <label *ngIf="!isEditModal && getResidentEmail()" class="img-checkbox" style="margin-bottom: -10px">
                        <input id="emailNotice" type="checkbox" formControlName="emailNotice" [ngModel]="true">
                        <label for="emailNotice">
                            <svg-checked></svg-checked>
                        </label>
                        <span>Email Notice to Resident(s)</span>
                    </label>

                    <div *ngIf="!getResidentEmail() && getResidentPhones().length > 0">
                        This resident cannot be notified by email as there is no email on file, please call them:
                        <span *ngFor="let phone of getResidentPhones()">
                            <br>
                            <span>{{ phone.getHumanReadableType() }}:</span> {{phone.phone}}
                        </span>
                    </div>

                    <div *ngIf="residentId.value && !getResidentEmail() && !getResidentPhones().length">
                        This resident does not have an email or phone number associated to it. Please update this
                        account.
                    </div>

                    <!-- Set Resident Email form -->
                    <add-resident-email-form
                        *ngIf="residentId.value && !getResidentEmail() && canEditDirectory()"
                        [resident]="selectedResident"
                        [suiteUser]="selectedSuiteUser"
                    >
                    </add-resident-email-form>

                    <label
                        *ngIf="!isEditModal && !getResidentEmail() && selectedResident?.getMobilePhone() && smsIsEnabled()"
                        class="img-checkbox">
                        <input id="smsNotice" type="checkbox" formControlName="smsNotice" [ngModel]="true">
                        <label for="smsNotice">
                            <svg-checked></svg-checked>
                        </label>
                        <span>Send SMS notification to {{selectedResident?.getMobilePhone()}}</span>
                    </label>

                    <div class="row text-center m-b-lg m-t-md">
                        <button type="submit" form="parcelForm" class="btn btn-primary submit-btn"
                                [disabled]="loading.global">
                            Save
                        </button>
                    </div>
                    <spinner [spinnerShow]="loading.global"></spinner>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-modal/parcel-modal.component.html